{
  "cancel": "Annuler",
  "delete": "Supprimer",
  "close": "Fermer",
  "done": "Fait",
  "deleteTitle": "Supprimer l'enregistrement ?",
  "deleteText": "Supprimer définitivement cet enregistrement ?",
  "info": "Informations",
  "objectInfoTitle": "Informations de l'enregistrement",
  "createdBy": "Créé par",
  "createdAt": "Créé le",
  "lastEditedBy": "Dernière modification par",
  "editedAt": "Modifié le",
  "unknown": "Inconnu",
  "system": "Système",
  "objectHistoryTitle": "Enregistrement et historique",
  "changes": "Modifications",
  "loadingHistory": "Chargement de l'historique…",
  "noHistory": "Aucun historique de modification pour le moment.",
  "historyLoadError": "Impossible de charger l'historique.",
  "someone": "Quelqu'un",
  "historyDate": "Date",
  "historyUser": "Utilisateur",
  "historyChange": "Modification",
  "actionCreated": "a créé",
  "actionDeleted": "a supprimé",
  "actionChanged": "a modifié",
  "historyFallbackWithTitle": "« {{title}} » {{verb}}",
  "historyFallback": "Entrée {{verb}}",
  "updateAvailable": "Mise à jour disponible",
  "updateBody": "Une nouvelle version de cette application est disponible.\nUne mise à jour est requise pour une expérience optimale.",
  "updateLater": "Mettre à jour plus tard",
  "updateNow": "Mettre à jour",
  "internetRequired": "(Internet requis)",
  "releaseInfo": "Notes de version",
  "selectMandant": "Sélectionner le client",
  "noLicence": "Aucune licence disponible",
  "noCompanyAssigned": "Vous n'êtes affecté à aucune entreprise.",
  "companiesLoadError": "Les entreprises n'ont pas pu être chargées",
  "logout": "Se déconnecter"
}
